var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div> <span data-bind="text: message"></span><!-- ko if: isDanger --> <div style="margin-top:8px; font-size:14px; color:#fff"> Обратитесь в <a href="https://www.rgs.ru/feedback?reason=%D0%9B%D0%B8%D1%87%D0%BD%D1%8B%D0%B9%20%D0%BA%D0%B0%D0%B1%D0%B8%D0%BD%D0%B5%D1%82&requestType=%D0%9E%D1%88%D0%B8%D0%B1%D0%BA%D0%B0%20%D0%BF%D1%80%D0%B8%20%D0%B2%D0%BD%D0%B5%D1%81%D0%B5%D0%BD%D0%B8%D0%B8%20%D0%B8%D0%B7%D0%BC%D0%B5%D0%BD%D0%B5%D0%BD%D0%B8%D0%B9%20%D0%B2%20%D0%9E%D0%A1%D0%90%D0%93%D0%9E"target="_blank"rel="noopener"style="color:#FFF; text-decoration:underline"> техподдержку. </a> </div><!-- /ko --> </div>';
}
return __p;
};
